export default {
  constants:{
    Previous: "पिछला",
    Next: "अगला",
    Page: "पेज",
    viewAll: "सभी देखें",
    of: "ऑफ",
    size: "साइज",
    material: "मैटेरियल",
    name: "नाम",
    email: "ईमेल",
    message: "संदेश",
    submit: "सबमिट करें",
    close: "बंद करें",
    sending: "भेजा जा रहा है...",
  },
  alertMessages: {
    successMessageContact: "आपका अनुरोध सफलतापूर्वक सबमिट कर दिया गया है!",
    errorMessageContact: "आपकी पूछताछ सबमिट करने में त्रुटि हुई। कृपया बाद में पुनः प्रयास करें।",
    serverErrorContact: "सर्वर उपलब्ध नहीं है। बाद में पुनः प्रयास करें।",
  },
  navbar: {
    menu: {
      Home: "होम",
      Category: "कैटेगरी",
      Blog: "ब्लॉग",
      AboutUs: "हमारे बारे में",
      ContactUs: "संपर्क करें",
    },
  },
  featureHighlights: {
    header: "अपने सपनों के प्रोजेक्ट को 4 चरणों में पूरा करें",
    description:
      "क्या आप अपने सपनों की कलाकृति डिजाइन करना चाहते हैं? हम आपके लिए सुंदर मंदिर, मूर्तियाँ और कलाकृतियाँ बनाते हैं।",
    features: [
      {
        icon: "/assets/featurehighlights/OneToOne.png",
        title: "1. आइए व्यक्तिगत रूप से जुड़ें",
      },
      {
        icon: "/assets/featurehighlights/ExploreCatalog.png",
        title: "2. हमारे कैटलॉग को एक्सप्लोर करें",
      },
      {
        icon: "/assets/featurehighlights/PlaceOrder.png",
        title: "3. ऑर्डर प्लेस करें",
      },
      {
        icon: "/assets/featurehighlights/DeliveryInstallation.png",
        title: "4. डिलीवरी और स्थापना",
      },
      /*{ 
        icon: '/assets/featurehighlights/Continuous_Improvements.png', 
        title: 'निरंतर सुधार' 
      }*/
    ],
  },
  HomeCategorySwipper: {
    viewAllCategories: "सभी श्रेणियाँ देखें",
    viewAll: "सभी देखें",
  },
  HomeClient: {
    completedProjects: "पूर्ण किए गए कस्टम प्रोजेक्ट",
    projects: "परियोजनाओं",
    countries: "देशों",
    yearsExperience: "वर्षों का अनुभव",
    ourClients: "हमारे ग्राहक",
  },
  footer: {
    address: "पता",
    addressDetails: "दुकान 2161, दूसरा क्रॉस कजानो वालो का रास्ता, चांदपोल बाजार, जयपुर, राजस्थान 302001",
    Call: "कॉल",
    CallValue: "+91 8905046144",
    Email: "ईमेल",
    EmailValue: "harshpandey9079@gmail.com",
    houseOfPandey: "हाउस ऑफ पांडे",
    home: "होम",
    category: "कैटेगरी",
    blog: "ब्लॉग",
    aboutUs: "हमारे बारे में",
    contactUs: "संपर्क करें",
    quickLinks: "क्विक लिंक्स",
    howItWorks: "हाउ इट वर्क्स",
    needHelp: "नीड हेल्प",
    faqs: "एफएक्यू",
    stores: "स्टोर्स",
    callUs: "कॉल अस",
    EmailUs: "ईमेल अस",
    followUs: "फॉलो अस",
    instagram: "इंस्टाग्राम",
    pinterest: "पिनट्रेस्ट",
    facebook: "फेसबुक",
    youtube: "यूट्यूब",
    twitter: "ट्विटर",
    linkedin: "लिंक्डइन",
    shopName: "पांडे आर्ट्स शॉप",
    rightsReserved: "ऑल राइट्स रिजर्व्ड",
    workingHours: "सोमवार से रविवार | सुबह 10 बजे से रात 8 बजे तक"
  },
  category: {
    productCategory: "प्रोडक्ट कैटेगरी",
    viewAll: "सभी देखें",
  },
  products: {
    viewProduct: "प्रोडक्ट देखें",
  },
  productDetails: {
    inStock: "इन स्टॉक",
    outOfStock: "आउट ऑफ स्टॉक",
    relatedProducts: "संबंधित प्रोडक्ट्स",
    share: "शेयर",
    inquireNow: "इन्क्वायर नाउ फॉर फ्री कोट",
    whatsappInquiry: "वॉट्सऐप अस फॉर फ्री कोट",
    shareProductOn: "प्रोडक्ट को शेयर करें",
    callUsFree: "हमें कॉल करें",
    emailUsFree: "हमें ईमेल करें",
    sizeMessage: "कस्टमाइज्ड साइज अवेलेबल एज़ पर योर नीड",
    materialMessage: "कस्टमाइज्ड मैटेरियल अवेलेबल एज़ पर योर नीड",
  },
  contactUs: {
    ourTeam: "हमारी टीम",
    rajeshPandey: "राजेश पांडे",
    harshPandey: "हर्ष पांडे"
  },
  contactUsForm: {
    talkToExpert: "हमारे विशेषज्ञ से बात करें",
    forFree: "निःशुल्क",
    fullName: "पूरा नाम",
    email: "ईमेल",
    phone: "फोन नंबर",
    city: "शहर",
    tellUsMessage: "हमें अपने बारे में बताएं",
    homeOwnerMessage: "मैं एक गृहस्वामी हूँ जो पत्थर की कला की तलाश में है।",
    designerMessage: "मैं एक इंटीरियर डिजाइनर/आर्किटेक्ट हूँ जो अपने क्लाइंट के लिए समाधान ढूंढ रहा हूँ।",
    contactUsFree: "हमसे निःशुल्क संपर्क करें",
  },
  relatedProducts: {
    relatedProducts: "संबंधित प्रोडक्ट्स",
    viewMore: "और देखें",
    viewDetails: "विवरण देखें",
  },
  aboutUs: {
    imageDescription: "जुनून और सटीकता के साथ कालातीत पत्थर की कलाकृतियों का निर्माण",
    ourStory: "हमारी कहानी",
    ourStoryDetails: "हम जुनूनी कलाकार हैं जो अद्वितीय पत्थर कला का निर्माण करने में समर्पित हैं, जो परंपरा, भक्ति और समय की सुंदरता की कहानी बताती है। सूक्ष्म रूप से मूर्ति और मंदिरों से लेकर आधुनिक पत्थर की दीवार कला तक, हर सृजन प्रतिष्ठा और कला के मिश्रण है।",
    outStoryDetails2: "दशकों के अनुभव के साथ, हमारा लक्ष्य प्राकृतिक पत्थर के सुंदरता को सभी महानगरों, कार्यस्थलों,और पवित्र स्थानों में पहुँचाना है।",
    ourMission: "हमारी मिशन",
    ourMissionDetails: "विश्व स्तरीय पत्थर की कलाकृतियाँ प्रदान करना जो सांस्कृतिक समृद्धि और आधुनिक सुंदरता को दर्शाती हों, साथ ही शिल्प कौशल को आने वाली पीढ़ियों के लिए जीवित रखना।",
    ourVision: "हमारी दृष्टि",
    ourVisionDetails: "पत्थर की कलाकृति में सबसे भरोसेमंद वैश्विक नाम बनना, जहां हर कृति कला और समर्पण की एक शाश्वत कहानी बयां करती है।",
    whyChooseUs: "हमें क्यों चुनें?",
    authenticStone: "असली पत्थर",
    authenticStoneDetails: "हम दीर्घायु सुंदरता के लिए केवल सर्वोत्तम गुणवत्ता वाले पत्थरों का उपयोग करते हैं।",
    handcraftedArt: "हस्तनिर्मित कला",
    handcraftedArtDetails: "प्रत्येक कृति को दशकों के अनुभव वाले कुशल कारीगरों द्वारा हाथ से तराशा जाता है।",
    globalReach: "विश्वव्यापी पहुँच",
    globalReachDetails: "स्थानीय मंदिरों से लेकर अंतरराष्ट्रीय परियोजनाओं तक, हमारी कला दुनिया भर में यात्रा करती है।",
    jaipurStore: "पांडे कला दुकान",
    storeAddress: "दुकान 2161, दूसरा क्रॉस कजानो वालो का रास्ता, चांदपोल बाजार, जयपुर, राजस्थान 302001",
    storeContactPhone: "संपर्क: +91 8905046144",
    storeContactEmail: "ईमेल: harshpandey9079@gmail.com",
    storeHours: "सोमवार से रविवार | सुबह 10 बजे से रात 8 बजे तक",
    jaipurWarehouse: "पांडे कला गोदाम",
    warehouseAddress: "दुकान 2161, दूसरा क्रॉस कजानो वालो का रास्ता, चांदपोल बाजार, जयपुर, राजस्थान 302001",
  }
};
